<template>
  <div class="app-exception">
    <div class="app-exception__img app-exception__img--403"></div>
    <h1>403</h1>
    <p>{{msg}}</p>
  </div>

</template>
<script>
export default {
  name: 'Forbidden',
  computed: {
    msg () {
      return this.$store.state.verifyError || '抱歉，你无权访问该页面'
    }
  }
}
</script>
